import { Reveal } from '@/components/ui/Reveal'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { herbalWalkGroup, courseWorkshop } from '@/assets/siteMedia'

export const ConsultationsImageStrip = () => (
  <section className="bg-base-50 pt-12 sm:pt-16">
    <div className="mx-auto max-w-6xl px-6">
      <Reveal>
        <div className="grid gap-4 sm:grid-cols-2">
          <SitePhoto
            src={herbalWalkGroup}
            alt="Kandake standing in front of a group, sharing plant knowledge outdoors"
          />
          <SitePhoto
            src={courseWorkshop}
            alt="Kandake presenting at a herbal course to a seated group"
          />
        </div>
      </Reveal>
    </div>
  </section>
)
